import { ErrorRuleConditionType } from "../../models/error-rule-condition-type";

export const ConditionTypes: ErrorRuleConditionType[] =  [
    {
        key: "ErrorCategory",
        name: "Error Category",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Error"
    },
    {
        key: "ErrorCode",
        name: "Error Code",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Error"
    },
    {
        key: "ErrorText",
        name: "Error Text",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" },
            { key: "Contains", name: "contains" }
        ],
        group: "Error"
    },

    {
        key: "DocumentType",
        name: "Document Type",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Document Type"
    },
    {
        key: "DocumentTypeGroup",
        name: "Document Type Group",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Document Type"
    },

    {
        key: "SenderPartner",
        name: "Sending Partner",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Partner"
    },
    {
        key: "ReceiverPartner",
        name: "Receiving Partner",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Partner"
    },
    {
        key: "SenderReceiverPartner",
        name: "Sending or Receiving Partner",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Partner"
    },

    {
        key: "SenderPartnerTag",
        name: "Sending Partner Tag",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Tags"
    },
    {
        key: "ReceiverPartnerTag",
        name: "Receiving Partner Tag",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Tags"
    },
    {
        key: "SenderReceiverPartnerTag",
        name: "Sending or Receiving Partner Tag",
        comparers: [
            { key: "Equals", name: "equals" },
            { key: "NotEquals", name: "is not equal to" }
        ],
        group: "Tags"
    },

    {
        key: "SenderPartnerConfiguration",
        name: "Sending Partner Configuration",
        comparers: null,
        group: "Configuration Keys"
    },
    {
        key: "ReceiverPartnerConfiguration",
        name: "Receiving Partner Configuration",
        comparers: null,
        group: "Configuration Keys"
    },
    {
        key: "SenderReceiverPartnerConfiguration",
        name: "Sending or Receiving Partner Configuration",
        comparers: null,
        group: "Configuration Keys"
    },
    {
        key: "DistributionConfiguration",
        name: "Distribution Configuration",
        comparers: null,
        group: "Configuration Keys"
    }
]
